import { FormControlLabel, Grid, Switch } from "@mui/material";
import { FastField } from "formik";
import {
  MySelect,
  MySelectTime,
  MyTextField,
  MyTextFieldArea,
  MyTextFieldUploadFile,
  UploadAnhDaiDien,
  UploadMultiFile
} from "../../Lib/componentLibrarys";
import Api from "../../../api2";
import { useState } from "react";
import { isEmpty } from "lodash";

export const FormNhap = ({ values, errors, setFieldValue, viTriList }) => {
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={12} className="fileGiayChungNhan" style={{}}>
          <UploadAnhDaiDien
            multi={false}
            title="Ảnh slide:"
            titleBtnUpload="Tải lên ảnh"
            file={values?.fileImages || []}
            handleChangeFile={values => setFieldValue(`fileImages`, values)}
            checkSave={false}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            required
            label="Vị trí:"
            placeholder="Chọn..."
            value={values?.viTri}
            options={viTriList || []}
            name="name"
            onChange={(event, value) => {
              setFieldValue(`viTri`, value);
            }}
            errors={errors?.viTri}
            helperText={errors?.viTri}
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            style={{ marginLeft: 0.5, alignItems: "center", marginTop: 20 }}
            control={
              <Switch
                checked={values?.hienThi}
                onChange={(event, value) => {
                  setFieldValue("hienThi", value);
                }}
              />
            }
            label="Hiển thị"
          />
        </Grid>
        <Grid item xs={6}>
          <FastField name="linkUrl">
            {({ field }) => (
              <MyTextField
                label="Link url:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="order">
            {({ field }) => (
              <MyTextField
                type="number"
                label="Order:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={12}>
          <FastField name="moTa">
            {({ field }) => (
              <MyTextFieldArea
                label="Mô tả:"
                placeholder="Nhập..."
                maxRows={3}
                {...field}
              />
            )}
          </FastField>
        </Grid>
      </Grid>
    </div>
  );
};
